import _ from 'lodash';

/**
 * 对象转换为列表
 *
 * 对象格式： {departs: [{id, name}], users: [{id, name}], tags: [{id, name}]}
 * 列表条目格式：[{allowType, allowId, allowName}]
 * allowType 参见 cn.anytech.wecom.model.enums.SysAppAllowType
 *
 * @param obj
 */
export function allowObj2List(obj) {
    if (_.isEmpty(obj)) {
        return [];
    }

    const {departs, users, tags, adtags} = obj;

    function convertIdNames(idNames, allowType) {
        if (_.isEmpty(idNames)) {
            return [];
        }

        return idNames.map(({id, name}) => ({allowType, allowId: id, allowName: name}));
    }

    return [
        ...convertIdNames(departs, 1),
        ...convertIdNames(users, 2),
        ...convertIdNames(tags, 3),
        ...convertIdNames(adtags, 4),
    ];
}

export function allowList2Obj(list) {
    if (_.isEmpty(list)) {
        return {};
    }

    return list.reduce((prev, cur) => {
        const {allowType, allowId, allowName} = cur;
        let type;

        if (allowType === 1) {
            type = 'departs';
        } else if (allowType === 2) {
            type = 'users';
        } else if (allowType === 3) {
            type = 'tags';
        } else if (allowType === 4) {
            type = 'adtags';
        } else {
            return prev;
        }

        return {...prev, [type]: [...(prev[type] ?? []), {id: allowId, name: allowName}]};
    }, {});
}
